import classNames from "classnames";
import {FiLoader} from "react-icons/fi";
import {HiOutlineSparkles} from "react-icons/hi2";

import Button from "@/components/button/Button.tsx";
import {Icon} from "@/components/icon/Icon.tsx";

import {BrandLookupStatus} from "./useBrandLookup.ts";

import styles from "./BrandDetectButton.module.scss";

interface BrandDetectButtonProps {
  status: BrandLookupStatus;
  onDetect: () => void;
}

// The "Auto-detects brand assets" affordance rendered beside the Website URL label. Clicking it
// fetches the brand for the entered URL and fills the logo + header colors.
export const BrandDetectButton = ({status, onDetect}: BrandDetectButtonProps) => {
  const loading = status === "loading";
  return (
    <Button variant={"linkBlue"} size={"fitContent"} typography={"normal"} onClick={onDetect} disabled={loading}>
      <span className={styles.content}>
        <Icon
          icon={loading ? FiLoader : HiOutlineSparkles}
          size={"chip"}
          display={"inline"}
          removeDivDimensions
          className={classNames({[styles.spin]: loading})}
        />
        {loading ? "Detecting…" : "Auto-detects brand assets"}
      </span>
    </Button>
  );
};
